var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"whatsAPP pointer",on:{"click":_vm.whatsAPPClick}},[_c('img',{attrs:{"src":require("@/assets/img/Group 1877.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }